import { css } from '@linaria/core'
import CheckIcon from '#icons/check-16.svg'
import { style } from '#styles/index'

export const partPeriodInputClass = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 4px 8px;
  border: 1px solid ${style.theme.borderInput};
  min-height: 30px;
  font-size: inherit;

  color: ${style.theme.textDefault};
  background-color: ${style.theme.backgroundSurfacePrimary};
  outline: 2px solid transparent;
  transition: 0.25s ease border-color, 0.25s ease outline-color, 0.25s ease color;
  outline-offset: -2px;

  &._disabled {
    pointer-events: none;
    background-color: ${style.theme.backgroundSurfaceTertiary};
    border-color: ${style.theme.textSoft};
    
    > ._icon {
      background-color: ${style.theme.textSoft};
    }
  }
  
  &:hover {
    border-color: ${style.theme.borderHover}
  }

  &:focus {
    outline-color: ${style.theme.borderOutline};
    border-color: ${style.theme.borderOutline};
  }
  
  > ._period {
    font-variant: tabular-nums;
  }
  
  > ._icon {
    background-color: ${style.theme.textSoft};
  }
`

export const checkboxClass = css`
  cursor: pointer;
  flex-shrink: 0;
  appearance: none;
  display: inline-block;
  position: relative;
  margin: 0;
  border: 1px solid ${style.theme.textSoft};
  background: ${style.theme.backgroundSurfacePrimary};
  transition: all 0.5s ease;
  width: 20px;
  height: 20px;

  &:hover,
  &:focus-within {
    border: 1px solid ${style.theme.borderDanger};
    transition: border 0.5s ease;
  }

  &:checked {
    border: 1px solid ${style.theme.borderDanger};
    background: ${style.theme.backgroundSurfaceAccentDefault};
    transition: all 0.5s ease;

    &:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 1px;
      width: 16px;
      height: 16px;
      background: ${style.theme.backgroundSurfacePrimary};
      mask-image: url(${CheckIcon});
      mask-size: cover;
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  ._select-interactive:hover & {
    border: 1px solid ${style.theme.borderDanger};

    &:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 1px;
      width: 16px;
      height: 16px;
      background: ${style.theme.borderDanger};
      mask-image: url(${CheckIcon});
      mask-size: cover;
    }
  }
`
